import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PageTitleManager() {
  const location = useLocation();
  const { t, i18n } = useTranslation('common');

  useEffect(() => {
    const path = location.pathname.toLowerCase().replace(/\/$/, '') || '/';
    let titleKey = 'home';

    if (path === '' || path === '/' || path === '/2024') {
      titleKey = 'home';
    } else if (path === '/pricing' || path === '/2024/pricing') {
      titleKey = 'pricing';
    } else if (path === '/about' || path === '/2024/aboutus') {
      titleKey = 'about';
    } else if (path === '/features' || path === '/2024/features') {
      titleKey = 'features';
    } else if (path === '/security' || path === '/2024/security') {
      titleKey = 'security';
    } else if (path === '/partners' || path === '/2024/patners') {
      titleKey = 'partners';
    } else if (path === '/contact' || path === '/2024/contact') {
      titleKey = 'contact';
    } else if (path === '/privacy' || path === '/privacy-policy' || path === '/2024/privacy') {
      titleKey = 'privacy';
    } else if (path === '/terms' || path === '/terms-conditions' || path === '/2024/terms') {
      titleKey = 'terms';
    } else if (path === '/waiting-list' || path === '/2024/waitinglist') {
      titleKey = 'waitingList';
    } else {
      titleKey = 'default';
    }

    const localizedTitle = t(`pageTitles.${titleKey}`, {
      defaultValue: 'RequireSign | Unlimited E-Signatures'
    });

    if (typeof document !== 'undefined') {
      document.title = localizedTitle;
    }
  }, [location.pathname, i18n.language, t]);

  return null;
}
